import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';
import { CreateTrainingLevelDto, NewTrainingLevelStore } from 'stores/configuration/events-n-requests/training-levels-store';
import { nameof } from 'utils/object';

interface NewTrainingLevelViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newTrainingLevel?: NewTrainingLevelStore;
}

interface NewTrainingLevelViewState {
  userClickedSaved: boolean;
}

@connect(['newTrainingLevel', NewTrainingLevelStore])
class NewTrainingLevelView extends React.Component<NewTrainingLevelViewProps, NewTrainingLevelViewState> {
  private get newTrainingLevelStore() {
    return this.props.newTrainingLevel;
  }

  constructor(props: NewTrainingLevelViewProps) {
    super(props);
    this.newTrainingLevelStore.createNew({
      name: ''
    });
    this.state = {
      userClickedSaved: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: NewTrainingLevelViewProps) {
    if (this.newTrainingLevelStore.state.result && this.newTrainingLevelStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onCreateNewItem() {
    this.setState({ userClickedSaved: true });
    this.newTrainingLevelStore.submit();
  }

  @autobind
  private onCancelNewItem() {
    this.newTrainingLevelStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.newTrainingLevelStore.change({ ...this.newTrainingLevelStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.newTrainingLevelStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('New Training Level')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.newTrainingLevelStore.state.result && !this.newTrainingLevelStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.newTrainingLevelStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.newTrainingLevelStore.state.item && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    required
                    fluid
                    error={!this.newTrainingLevelStore.state.item.name && this.state.userClickedSaved}
                    label={t('Training Level')}
                    placeholder={t('Name')}
                    value={this.newTrainingLevelStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateTrainingLevelDto>('name'), value)}
                  />
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onCreateNewItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewTrainingLevelView);
